import { Component, OnInit, OnDestroy, Directive, Renderer2, Inject, ViewChild, ElementRef	 } from '@angular/core';
import { Router } from '@angular/router';
import { async, lastValueFrom, Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';

import { CartService } from 'src/app/shared/services/cart.service';
import { ModalService } from 'src/app/shared/services/modal.service';



import { NgxPayPalModule } from 'ngx-paypal';
import { json } from 'stream/consumers';
import { element } from 'protractor';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { domainMetaMap } from 'src/app/shared/countries';
import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { Product } from 'src/app/shared/classes/product';

declare var $: any;

@Component({
	selector: 'shop-checkout-page',
	templateUrl: './checkout.component.html',
	styleUrls: ['./checkout.component.scss']
})


export class CheckoutComponent implements OnInit, OnDestroy {

	cartItems = [];
	cashSelected = false;
	cardSelected = false;
	public banktransferSelected = false;
	countries:any;
	paramPoints:boolean=true;
	@ViewChild('points2Redeem') points2Redeem: ElementRef;
	total_price:number=0.00;
	public stop = false;
	public isProcessing:boolean = false;
	public isSpinning = false;


	private subscr: Subscription;

	constructor(public cartService: CartService, public apiService:ApiService, public modalService:ModalService, 
				@Inject(Router) public router:Router,@Inject(Renderer2) private renderer: Renderer2,  @Inject(DOCUMENT) private document: Document, 
				@Inject(Title)private titleService:Title) {
		
	}

	async ngOnInit(): Promise<void> {	
		try {
			if (typeof window !== 'undefined') {
				//get countries based on domain name			
				let domainName = window.location.hostname;
				this.countries = domainMetaMap[domainName];
				//set the country user has registered with
				//(<HTMLInputElement>document.getElementById('country')).value = this.apiService.userInfo[0].CUSTCOUNTRY;
	
				if(!this.apiService.shippingId){
					this.apiService.shippingId = JSON.parse(localStorage.getItem('shipping_id'));
					this.apiService.shippingDesc = JSON.parse(localStorage.getItem('shipping_description'));
					this.apiService.shippingCost = JSON.parse(localStorage.getItem('shipping_cost'));
				}
	
				this.subscr = this.cartService.cartStream.subscribe(items => {
					this.cartItems = items;
				});
	
				document.querySelector('body').addEventListener("click", () => this.clearOpacity())
	
					//check if user is loged in
					if(this.apiService.userInfo.length == 0){
						//this.apiService.popupMsg("Sign in first","Please login to proceed","info");
						this.router.navigate(['/shop/dashboard']);																
					}				
			}
			this.getTotalWithShipping(this.cartService.priceTotal);
		} catch (error) {
			await this.apiService.logError(error, this.router.url);
		}			
	}

	ngOnDestroy(): void {
		this.subscr.unsubscribe();
		document.querySelector('body').removeEventListener("click", () => this.clearOpacity())
	}

	clearOpacity() {
		let input: any = document.querySelector('#checkout-discount-input');
		if (input && input.value == "") {
			let label: any = document.querySelector('#checkout-discount-form label');
			label.removeAttribute('style');
		}
	}

	addOpacity(event: any) {
		event.target.parentElement.querySelector("label").setAttribute("style", "opacity: 0");
		event.stopPropagation();

	}

	formToggle(event: any) {
		const parent: HTMLElement = event.target.closest('.custom-control');
		const submenu: HTMLElement = parent.closest('.form-group').querySelector('.shipping-info');

		if (parent.classList.contains('open')) {
			$(submenu).slideUp(300, function () {
				parent.classList.remove('open');
			});
		}
		else {
			$(submenu).slideDown(300, function () {
				parent.classList.add('open');
			});
		}

		event.preventDefault();
		event.stopPropagation();
	}

	async placeOrderClicked(event:any){
		try {			
			//console.log(this.cashSelected + " "+ this.cardSelected);
			event.preventDefault();
			this.isProcessing=true;
			//save shiiping cost and id and description because if the go back from vivawallet payment shipping is lost
			
			let notes = (<HTMLInputElement>document.getElementById("orderNotes")).value;
			if(this.apiService.userInfo.length == 0){
				this.apiService.popupMsg("Login first!","Please login to checkout","info");			
			}
			else if(!this.cashSelected && !this.cardSelected && !this.banktransferSelected){
				this.apiService.popupMsg("Payment Method!","Please select a payment method.","error");
			}
			else{
				this.isSpinning=true;				
				if(await this.checkStockBeforePay())
					return;
				
				
				let payment:string="";
				if(this.cashSelected)					
					payment = "Cash on Delivery"
				else 
					if(this.banktransferSelected)
						payment = "Bank Transfer"
					//console.log(JSON.stringify(this.cartItems).length*8);
					//remove description from each product before sending it to api
					let cartItemsNoDesc = this.removeDesc(this.cartItems);
					let res = await lastValueFrom(this.apiService.saveOrderPromise(cartItemsNoDesc, this.cartService.priceTotal['_value'], notes, payment));
					//console.log(JSON.stringify(cartItemsNoDesc).length*8);
					if(res != "success")
					{
						this.apiService.popupMsg("Something went wrong!","Order not saved.","error");
						//console.log(res);
					}
					else{
						await lastValueFrom(this.apiService.sendEmailCompany(this.cartItems));
						await lastValueFrom(this.apiService.sendCustomerConfirmationEmail(this.cartItems));
						this.isSpinning=false;
						this.apiService.popupMsg("Congrats!","Completed successfully","info");
						this.router.navigate(['/']);
						//clear cart
						this.cartItems.forEach(item =>{
							this.cartService.removeFromCart(item);
						})				
					}
			}		
			//this.isProcessing=false;	
		} catch (error) {
			this.apiService.logError(error,this.router.url);
		}				
	}

	removeDesc(items:any){
		items.forEach(item => {
			item.description = '';
		});
		return items;
	}

	getTotalWithShipping(total: any){		
		this.total_price = Number(total.value)+this.apiService.shippingCost;
		return this.total_price;
	}

	calcVAT(customerVat){
		/* not used
		let net=0.00;
		let vat=0.00;
		
			
		if(this.cartItems.length > 0){      
		  //reset discount
		  let discountamount=0.00;
		  this.cartItems.forEach(element => {
			let qty= element.qty;
						
			if(element.PRODWITHVAT==1){             
			  if(customerVat>0){//if the customer has vat then use that one instead of the product vat          
				
				let tmp_netamountttt = (element.sale_price / (1 + customerVat/100 ) *qty).toFixed(2);
				let tmp_netamount = Number(tmp_netamountttt);
				
				let tmp_vatt = (Number(tmp_netamount) * customerVat /100).toFixed(2);
				let tmp_vat = Number(tmp_vatt);
				vat+= tmp_vat;
				if(element.sale_price * qty > tmp_netamount + tmp_vat){
					tmp_netamount += (element.sale_price * qty) - (tmp_netamount + tmp_vat);
				}
				else if(element.sale_price * qty < tmp_netamount + tmp_vat){
				  //tmp_netamount -= (tmp_netamount + tmp_vat)- (element.PRODSALESPRISES * qty);
				  let diff= (tmp_netamount + tmp_vat)- (element.sale_price * qty);
				  discountamount += Number(diff.toFixed(2));
				}
				net+=tmp_netamount;
			  
			  }
			  else{ //calculate the prices using the VAT on the item/product
				//let qty = this.cartItemsQtty[this.cartItems.indexOf(element)]; //1
				let tmp_netamountttt = (element.sale_price / (1 + element.PRODVAT/100 ) *qty).toFixed(2);
				let tmp_netamount = Number(tmp_netamountttt);
				
				let tmp_vatt = (Number(tmp_netamount) * element.PRODVAT /100).toFixed(2);
				let tmp_vat = Number(tmp_vatt);
				vat+= tmp_vat;
				if(element.sale_price * qty > tmp_netamount + tmp_vat){
					tmp_netamount += (element.sale_price * qty) - (tmp_netamount + tmp_vat);
				}
				else if(element.sale_price * qty < tmp_netamount + tmp_vat){
				  //tmp_netamount -= (tmp_netamount + tmp_vat)- (element.PRODSALESPRISES * qty);
				  let diff= (tmp_netamount + tmp_vat)- (element.sale_price * qty);
				  discountamount += Number(diff.toFixed(2));
				}
				net+=tmp_netamount;
			  }
			  
			  
			}
			else{//if product does not have vat in the price
			  net+=(element.sale_price * qty);//this.cartItemsQtty[this.cartItems.indexOf(element)]);
			  if(customerVat>0){//if the customer has vat then use that one insted of the product vat
				vat+=(element.sale_price * customerVat /100 * qty);//this.cartItemsQtty[this.cartItems.indexOf(element)]);//1
			  }
			  else{
				vat+=(element.sale_price * element.PRODVAT /100 *  qty);//this.cartItemsQtty[this.cartItems.indexOf(element)]);//1
			  }
			}
			  
		  });
		  //this.totalamount = this.netamount + this.vatamount - this.discountamount; 
		  //this.netamount = net;
		  //this.vatamount = vat;
		  //this.totalamount = this.netamount + this.vatamount - this.discountamount;    
		}
		//setup the table for vat net and total
		//netVatTotalArray[0].amount=this.netamount;
		//netVatTotalArray[1].amount=this.vatamount;
		//netVatTotalArray[2].amount=this.discountamount;
		//netVatTotalArray[3].amount=this.totalamount;
		//this.datasource2 = netVatTotalArray;
		
	}
	*/
	}

	creditCard_clicked(){
		//this.loadPaypalScript();
		this.cashSelected = false; 
		this.cardSelected = true;
		this.banktransferSelected = false;
		
	}

	cash_clicked(){
		this.cashSelected = !this.cashSelected;//toggles place order when you click and then click again to dissappear
		this.cardSelected = false;
		this.banktransferSelected = false;
	}

	banktransfer_clicked(){
		this.cashSelected = false;
		this.cardSelected = false;
		this.banktransferSelected = !this.banktransferSelected;//toggles place order when you click and then click again to dissappear
	}

	async viva_payment(event){	
		event.preventDefault();
		this.storeDetails();
		//check stock first
		if(await this.checkStockBeforePay())
			return;
		//setup the customer info to be send to the api for the paymentd
		//type my_cust_info = Array<{Column_Name: string, Column_Value: string}>;             
		let cust_info = [
			{
				"email": this.apiService.userInfo[0].CUSTEMAIL, 
				"name":  this.apiService.userInfo[0].CUSTNAME, // + " "+  this.apiService.userInfo[0].CUSTSURNAME,
				"phone": this.apiService.userInfo[0].CUSTMOBILEPHONE,
				"amount": (this.cartService.priceTotal['_value']+this.apiService.shippingCost - this.apiService.redeemPoints)*100, //this is because viva payment amount work like jcc when typing the amount, you have to have the extra zeros
				"merchantTrns": this.apiService.company_name + " Customer Payment",
				"customerTrns": "Your Products Payment"
			},
		]
		//serialise cust info with JSON
		let authentication = this.apiService.viva_auth.trim();//"MWNkNDJhNGUtYzQ4NC00NGUyLTlkNzQtODA0OWM4MzgwMGFmOkJBJUdwMQ==";
		let cust_info_string=JSON.stringify(cust_info); //https://www.vivapayments.com/api/orders old one
		let res:any = this.apiService.fetchOrderCode(cust_info_string, "https://www.vivapayments.com/api/orders", authentication).subscribe((res: any) => {
			let ordercode = res.OrderCode;
			localStorage.setItem('onlinepaymentcode',JSON.stringify(res));			
			//redirect user to wallet in order to complete the payment
			window.location.href = "https://www.vivapayments.com/web/checkout?ref="+ordercode;			
			//window.open ("https://www.vivapayments.com/web/checkout?ref=" + ordercode);
			//window.open('https://demo.vivapayments.com/web/checkout?ref='+ordercode,'_blank');
			//https://demo.vivapayments.com/api/orders
			//https://www.vivapayments.com/api/orders
		});    

	}

	storeDetails(){
		if(this.apiService.shippingId){
			if (typeof window !== 'undefined') {
				localStorage.setItem('shipping_id',JSON.stringify(this.apiService.shippingId));
				localStorage.setItem('shipping_description',JSON.stringify(this.apiService.shippingDesc));
				localStorage.setItem('shipping_cost',JSON.stringify(this.apiService.shippingCost));				
			}
		}
		if (typeof window !== 'undefined') {
			localStorage.setItem('cartItems',JSON.stringify(this.cartItems));
			localStorage.setItem('loginData',JSON.stringify(this.apiService.userInfo));
			localStorage.setItem('totalPrice',JSON.stringify(this.cartService.priceTotal['_value']));
			localStorage.setItem('redeemPoints',JSON.stringify(this.apiService.redeemPoints));
		}
		let notes = (<HTMLInputElement>document.getElementById("orderNotes")).value;$
		if (typeof window !== 'undefined') 
			if(notes != null || notes != "")
				localStorage.setItem('notes',JSON.stringify(notes));		
	}

	

	async checkStockBeforePay(){
			/**
			 * check if items are in stock and abort payment if neccessary
			*/			
			for(let i=0; i<this.cartItems.length;i++){
				let res:any = await lastValueFrom(this.apiService.getSingleProductPromise(this.cartItems[i].id));
				if(this.cartItems[i].qty > res.product.stock ){										
					this.apiService.popupMsg("Out of Stock!\n"+this.cartItems[i].name,"Available stock: "+res.product.stock,"error");
					return true;						
				}
			}		
		return false;
	}	
	
}
